const timeBidContractAddress = "0xea44B14A4A244e3E927658A59A4c2F4b4d9408C1"

export default timeBidContractAddress